import React from 'react';
import IconLink from "../common/IconLink";
import { useTranslation } from '../../i18n/LanguageProvider';


// https://web.archive.org/web/20250517002846/https://ppgcc.ufsc.br/2025/05/14/resultado-da-selecao-da-tese-escolhida-para-concorrer-ao-premio-capes-de-teses-2025-edital-n-062025capes/

const awards = [
  {
    year: 2026,
    title: 'Best PhD Thesis Award — SBSeg 2026',
    externalLinks: [
      {
        href: '/publications/2026-ctd',
        tooltip: 'Thesis', tooltipPt: 'Tese'
      },
      {
        href: '/images/2026-sbseg-award/photo.jpg',
        tooltip: 'Photo', tooltipPt: 'Foto'
      },
      {
        href: '/publications/other/2026-ctd-certificate.pdf',
        tooltip: 'Certificate', tooltipPt: 'Certificado'
      }
    ],
    titlePt: 'Prêmio de Melhor Tese de Doutorado — SBSeg 2026',
    descriptionPt: 'Prêmio concedido pela tese de doutorado apresentada no Concurso de Teses e Dissertações (CTD) do Simpósio Brasileiro de Cibersegurança (SBSeg).',
    description:
      'Award granted for the PhD thesis presented at the Thesis and Dissertation Contest (CTD) of the Brazilian Symposium on Cybersecurity (SBSeg).'
  },
  {
    year: 2024,
    title: 'Inova UFSC Award',
    externalLinks: [
      {
        href: 'https://web.archive.org/web/20240423222922/https://noticias.ufsc.br/2024/04/premio-inova-ufsc-2024-esta-com-inscricoes-abertas/',
        tooltip: 'About', tooltipPt: 'Sobre'
      },
      {
        href: 'https://web.archive.org/web/20241205084853/https://noticias.ufsc.br/2024/11/premio-inova-ufsc-celebra-trabalhos-e-agentes-de-inovacao-da-universidade/',
        tooltip: 'Recipients announced', tooltipPt: 'Vencedores anunciados'
      }
    ],
    titlePt: 'Prêmio Inova UFSC',
    descriptionPt: '"A iniciativa buscou valorizar o surgimento de projetos e soluções inovadoras nas áreas de ensino, pesquisa, extensão e gestão universitária, fortalecendo a cultura de inovação na academia e fomentando o desenvolvimento de competências ligadas à geração, ao compartilhamento e à aplicação de novas ideias e conhecimentos."',
    description:
      '"The initiative sought to value the emergence of innovative projects and solutions in the areas of teaching, research, extension and university administration, in order to strengthen the culture of innovation in academia and to foster the levels of development of skills linked to the generation, sharing and application of new ideas and knowledge."'
  },
  {
    year: 2024,
    title: 'Vittorio Bertocci Award',
    externalLinks: [
      {
        href: 'https://web.archive.org/web/20240527224621/https://digitalidadvancement.org/awards-and-grants/vittorio/',
        tooltip: 'About', tooltipPt: 'Sobre'
      },
      {
        href: 'https://web.archive.org/web/20240821003415/https://digitalidadvancement.org/news/celebrating-excellence-meet-the-first-vittorio-bertocci-award-winners/',
        tooltip: 'Recipients announced', tooltipPt: 'Vencedores anunciados'
      },
      {
        href: 'https://web.archive.org/web/20250108205217/https://digitalidadvancement.org/news/2024-vittorio-bertocci-awardee-reflections-frederico-schardong/',
        tooltip: 'ER 2024 experience', tooltipPt: 'Experiência no ER 2024'
      }
    ],
    titlePt: 'Vittorio Bertocci Award',
    descriptionPt: '"A missão do Vittorio Bertocci Award é honrar o legado de Vittorio Bertocci, inspirando e apoiando a próxima geração de especialistas em identidade que moldará os fundamentos da identidade digital."',
    description:
      '"The mission of the Vittorio Bertocci Award is to honor Vittorio Bertocci\'s legacy by inspiring and supporting the next generation of identity experts who will shape the foundation of digital identity."'
  },
  {
    year: 2022,
    title: 'Kim Cameron Award',
    externalLinks: [
      {
        href: 'https://web.archive.org/web/20240907200718/https://openid.net/announcing-the-2022-openid-foundation-kim-cameron-scholarship/',
        tooltip: 'About', tooltipPt: 'Sobre'
      },
      {
        href: 'https://web.archive.org/web/20240724064435/https://openid.net/2022-openid-foundation-kim-cameron-award-recipients-announced/',
        tooltip: 'Recipients announced', tooltipPt: 'Vencedores anunciados'
      },
      {
        href: 'https://web.archive.org/web/20240907202203/https://www.openid.net/frederico-schardongs-experience-as-a-kim-cameron-award-recipient/',
        tooltip: 'Identiverse 2022 Experience', tooltipPt: 'Experiência no Identiverse 2022'
      }
    ],
    titlePt: 'Kim Cameron Award',
    descriptionPt: '"O Kim Cameron Award da OpenID Foundation reconhece a importância de orientar uma nova geração de especialistas e formadores de opinião no campo da identidade centrada no usuário. A Fundação busca ampliar a representação de pessoas que demonstram interesse acadêmico e prático em temas alinhados à sua missão."',
    description:
      '"The OpenID Foundation Kim Cameron Award is a recognition of the importance of mentoring a new generation of domain experts and thought leaders in user centric identity. The Foundation is interested in increasing representation from those who\'ve demonstrated an academic and practical interest in subjects consistent with OpenID Foundation\'s Mission."'
  }
];

export default function Awards() {
  const { isPortuguese, t } = useTranslation();
  const localizedAwards = awards.map((award) => ({
    ...award,
    title: isPortuguese ? award.titlePt : award.title,
    description: isPortuguese ? award.descriptionPt : award.description,
    externalLinks: award.externalLinks.map((link) => ({
      ...link,
      tooltip: isPortuguese ? link.tooltipPt : link.tooltip,
    })),
  }));
  return (
    <div id="awards" className="card mb-4">
      <div className="card-body">
        <h2 className="card-title">{t('home.awards')}</h2>
        {localizedAwards.map((award, index) => (
          <React.Fragment key={index}>
            <div className="card-subtitle h6 mb-1">
              {/* Year badge
              <span pill color="secondary" className="badge me-1 mb-1 align-middle" style={{ fontSize: '0.70rem' }}>
                {award.year}
              </span> */}
              <p style={{display: "inline", marginRight: "3px"}}>{award.title}</p>
              {award.externalLinks.map((link, linkIndex) => (
                <IconLink key={linkIndex} href={link.href} label={link.tooltip}>
                  <i className='icon-link'></i>
                </IconLink>
              ))}
            </div>
            <p className="card-text">{award.description}</p>
            {index < awards.length - 1 && <hr />}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}
